export function hasFiniteAnnotationConfidence(annotation) {
  const value = annotation?.confidence;
  return value !== undefined && value !== null && value !== '' && Number.isFinite(Number(value));
}

export function normalizeTrainingConfidenceThreshold(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return 0;
  }
  return Math.max(0, Math.min(1, number));
}

export function passesTrainingConfidenceThreshold(annotation, threshold) {
  if (!hasFiniteAnnotationConfidence(annotation)) {
    return true;
  }
  return Number(annotation.confidence) >= normalizeTrainingConfidenceThreshold(threshold);
}
